// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DocumentQueryService {
   $timeout: any
   api: any
   appState: any
   data: any
   docDetail: any
   fire: any
   results: any
   utilities: any
   constructor(results: any, api: any, docDetail: any, utilities: any, appState: any, $timeout: any, hooksService: any) {
      this.getReviews = this.getReviews.bind(this)
      this.getAIDocs = this.getAIDocs.bind(this)
      this.searchReviews = this.searchReviews.bind(this)
      this.searchAIDocs = this.searchAIDocs.bind(this)
      this.results = results
      this.api = api
      this.docDetail = docDetail
      this.utilities = utilities
      this.appState = appState
      this.$timeout = $timeout
      this.data = {
         reviews: {},
         aiDocuments: {}
      }

      hooksService.setHooks(this, 'DocumentQueryService', ['new', 'update'], true)

      const sendUpdateOrRetrieve = () => {
         const {
            doc
         } = this.docDetail.scope
         if (["Book", "eBook"].includes(doc.content_type)) { this.sendUpdateOrRetrieve(this.data.reviews, this.getReviews, doc) }
         if (this.docDetail.scope.isAIPage) { return this.sendUpdateOrRetrieve(this.data.aiDocuments, this.getAIDocs, doc) }
      }

      // run sendUpdateOrRetrieve on initialization since docDetail hook won't be set up yet
      sendUpdateOrRetrieve()

      this.docDetail.on('new', sendUpdateOrRetrieve)

      this.results.on('update', () => {
         const resultData = this.results.data
         if (resultData.updateType === "reviews") {
            this.data.reviews[resultData.reviews.id] = resultData.reviews.reviews
         }
         if (resultData.updateType === "ai") {
            this.data.aiDocuments[resultData.aiDocuments.id] = resultData.aiDocuments.aiDocuments
         }
         if (["reviews", "ai"].includes(resultData.updateType)) { return this.fire('update') }
      })
   }

   sendUpdateOrRetrieve(collection: any, retrieveMethod: any, doc: any) {
      if (_.chain(collection).keys().contains(doc.id).value()) {
      // give directive some time for its doc val to change
         return this.$timeout((() => this.fire('update')), 100)
      } else {
         return retrieveMethod(doc)
      }
   }

   getReviews(doc: any) {
      const params = {
         q: this.formReviewsQuery(doc),
         id: doc.id
      }
      // give directive some time for its doc val to change
      return this.$timeout((() => {
         this.api.reviews(params)
         return this.fire('new')
      }
      ), 100)
   }

   getAIDocs(doc: any) {
      const params = {
         q: this.formAIDocsQuery(doc),
         id: doc.id
      }
      if (params.q) {
      // give directive some time for its doc val to change
         return this.$timeout((() => {
            this.api.aiDocuments(params)
            return this.fire('new')
         }
         ), 100)
      } else {
         this.data.aiDocuments[doc.id] = []
         // give directive some time for its doc val to change
         return this.$timeout((() => this.fire('update')), 100)
      }
   }

   searchReviews(doc: any) {
      const setState = () => {
         this.appState.resetParams()
         this.appState.params.q = this.formReviewsQuery(doc)
         return this.appState.params.fvf.push("ContentType,Book Review,f")
      }
      return this.appState.applyStateWithSnapShot(setState)
   }

   searchAIDocs(doc: any) {
      const setState = () => {
         this.appState.resetParams()
         return this.appState.params.q = this.formAIDocsQuery(doc)
      }
      return this.appState.applyStateWithSnapShot(setState)
   }

   formReviewsQuery(doc: any) {
      // remove highlighting from title and subtitle
      const title = this.utilities.removeHithighlightTags(doc.title)
      const subtitle = this.utilities.removeHithighlightTags(doc.subtitle ? `AND \"${doc.subtitle}\" ` : "")
      const authors = _.pluck((doc.authors || []).concat(doc.corporate_authors || []), "fullname").join(" ")
      return `\"${title}\" ${subtitle}${authors}`
   }

   formAIDocsQuery(doc: any) {
      let q = ""
      if ((doc.content_type === "Journal Article") && !_.isEmpty(doc.issns)) {
         return q = _.map(doc.issns, (issn: any) => `ISSN:${issn}`).join(" OR ")
      } else if ((doc.content_type === "Book Chapter") && !_.isEmpty(doc.isbns)) {
         return q = _.map(doc.isbns, (isbn: any) => `ISBN:${isbn}`).join(" OR ")
      } else {
         return q
      }
   }
}

DocumentQueryService.$inject = ['dataService', 'apiService', 'documentDetailService', 'utilitiesService', 'appStateService', '$timeout', 'hooksService']

angular.module('summonApp.services')
   .service('documentQueryService', DocumentQueryService)
